export const types = {
  SET_ERROR: 'ERROR/SET_ERROR',
};
export const actions = {
  setError: (data) => ({
    type: types.SET_ERROR,
    payload: { data },
  }),
};
const initialState = {
  service: null,
  errorToPrint: null,
  handlingCode: 0,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ERROR: {
      const { payload } = action;
      const { data } = { ...payload };
      const {
        service,
        errorToPrint,
        handlingCode,
        buttonHref,
        buttonText,
        homeUrl,
      } = {
        ...data,
      };
      return {
        ...state,
        service: service || state?.service,
        errorToPrint,
        handlingCode: handlingCode || state?.handlingCode,
        buttonText: buttonText || state?.buttonText,
        buttonHref: buttonHref || state?.buttonHref,
        homeUrl: homeUrl || state?.homeUrl,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default reducer;
